import { errorResponseHelper } from '@/helpers'
import { sessionPersistenceFailure } from '@/helpers/session-failure'
import { underLoadingFunction } from '../helpers/under-loading'
import CepHiveService from '@/services/cep.hive.service'

import {
  setToken
} from '@/auth'

const state = {
}

const mutations = {
}

const getters = {
}

const actions = {
  getCEP: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await CepHiveService.getCEP(payload)

      if (data.data && data.data.token) {
        if (!await setToken(data.data.token)) {
          const error = sessionPersistenceFailure('cep', 'token_write_failed')
          errorResponseHelper.display(error)
          return { success: false, error }
        }
      }

      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  })
}

export default {
  state,
  mutations,
  actions,
  getters
}
